import { Controller, useFormContext } from 'react-hook-form';

import { DatePicker } from 'components/DatePicker';
import { Typography } from 'components/typography';

import { QuickQuoteDatePickerProps, QuickQuoteInputs } from '../types';

export function QuickQuoteDatePicker({
  name,
  rules,
  className,
  calendarClassName,
  ...datePickerRest
}: QuickQuoteDatePickerProps) {
  const { control } = useFormContext<QuickQuoteInputs>();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <>
          <DatePicker
            {...datePickerRest}
            field={field}
            highlightError={!!fieldState.error}
            className={className}
            calendarClassName={calendarClassName}
          />
          {!!fieldState.error?.message && (
            <Typography variant='body-xs' className='mt-1 text-error-500'>
              {fieldState.error.message}
            </Typography>
          )}
        </>
      )}
    />
  );
}
